import { createBrowserRouter, Navigate } from 'react-router';
import { RedirectPokedex } from './RedirectPokedex';
import { NotFound } from '@/views/NotFound';
import { Login } from '@/views/Login';
import { Role } from '@/views/Role';
import { BlueMapViewer } from '@/views/Map';
import { Home } from '@/views/Home';
import { Pokemons } from '@/views/Pokemons';
import { PendingExpeditionPage } from '@/views/Expedition/PendingExpedition';
import { UltraBreche } from '@/views/UltraBreche';
import { Inventory } from '@/views/Inventory';
import { Trade } from '@/views/Trade';
import { AppLayout, PokemonsLayout } from '@/layouts/AppLayout';
import { PlayerPC } from '@/views/PlayerPC';
import { Videos } from '@/views/Videos';
import { Profile } from '@/views/Profile';
import { Pension } from '@/views/Pension';
import { DiscordApprove } from '@/views/DiscordApprove';
import { Fusion } from '@/views/Fusion';
import { Leaderboard } from '@/views/Leaderboard';
import { Pokedex } from '@/views/Pokedex';
import { Achievements } from '@/views/Achievements';

const router = createBrowserRouter([
  {
    path: '/',
    element: <AppLayout />,
    children: [
      {
        index: true,
        element: <Navigate to="/home" replace />,
      },
      {
        path: 'home',
        element: <Home />,
      },
      {
        path: 'role',
        element: <Role />,
      },
      {
        path: 'map',
        element: <BlueMapViewer />,
      },
      {
        path: 'achievements',
        element: <Achievements />,
      },
      {
        path: 'videos',
        element: <Videos />,
      },
      {
        path: 'profile',
        element: <Profile />,
      },
      {
        path: 'ultra-breche/:webToken',
        element: <UltraBreche />,
      },
      // ── Redirects vers /pokemons/* ───────────────────────────
      {
        path: 'pokedex',
        element: <Navigate to="/pokemons/pokedex" replace />,
      },
      {
        path: 'pokedex/:pokemonId',
        element: <RedirectPokedex />,
      },
      {
        path: 'pension',
        element: <Navigate to="/pokemons/pension" replace />,
      },
      {
        path: 'inventory',
        element: <Navigate to="/pokemons/inventory" replace />,
      },
      {
        path: 'leaderboard',
        element: <Navigate to="/pokemons/leaderboard" replace />,
      },
      // ── Section Pokémons avec sous-navigation ───────────────
      {
        path: 'pokemons',
        element: <PokemonsLayout />,
        children: [
          {
            index: true,
            element: <Pokemons />,
          },
          {
            path: 'pokedex',
            element: <Pokedex />,
          },
          {
            path: 'pokedex/:pokemonId',
            element: <Pokedex />,
          },
          {
            path: 'fusion',
            element: <Fusion />,
          },
          {
            path: 'pension',
            element: <Pension />,
          },
          {
            path: 'inventory',
            element: <Inventory />,
          },
          {
            path: 'leaderboard',
            element: <Leaderboard />,
          },
          {
            path: 'expedition/current',
            element: <Navigate to="/home" replace />,
          },
          {
            path: 'expedition/:pendingExpeditionId',
            element: <PendingExpeditionPage />,
          },
          {
            path: 'trade/:tradeId',
            element: <Trade />,
          },
        ],
      },
    ],
  },
  {
    path: '/pokemons/:username',
    element: <PlayerPC />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/auth/approve',
    element: <DiscordApprove />,
  },
]);

export default router;
